/** Central configuration for feature flags and shared constants. */

export const EMAIL_SENDER = 'noreply@bradescoseguros.com.br';

/** When `true`, skips the entire DRF terms gate, modal and validation failure screen. */
export const SKIP_DRF = true;

/** When `true`, skips the second step (2FA) of the login. */
export const SKIP_LOGIN_SECOND_STEP = true;

/** When `true`, skips the corporate email step. */
export const SKIP_CORPORATE_EMAIL_STEP = true;

/** Microsoft Entra ID — Authorization Code Flow with PKCE (frontend). */
export const ENTRA_ID_SCOPES = 'openid profile';
export const ENTRA_ID_CODE_CHALLENGE_METHOD = 'S256';
export const ENTRA_ID_RESPONSE_TYPE = 'code';
export const ENTRA_ID_RESPONSE_MODE = 'query';
export const ENTRA_ID_RETRY_LOADING_MS = 2000;
export const BACKOFFICE_ROLE_HEADER = 'BACKOFFICE';